(function() {
  function addCloseButton() {
    const selectors = ['[data-essential-cart-element="container-mobile"]', '[data-essential-cart-element="container-desktop"]'];
    
    selectors.forEach(selector => {
      const cartContainer = document.querySelector(selector);
      
      if (cartContainer && !cartContainer.querySelector('.custom-close-x')) {
        const closeBtn = document.createElement('div');
        closeBtn.className = 'custom-close-x';
        closeBtn.innerHTML = '×';
        
        closeBtn.style.cssText = `
          position: absolute; 
          top: 0; 
          right: 8px; 
          color: #fff; 
          cursor: pointer; 
          font-size: 24px;
          line-height: 1;
          z-index: 999999;
        `;
        
        closeBtn.onclick = (e) => {
          e.preventDefault();
          cartContainer.style.display = 'none';
        };
        
        cartContainer.appendChild(closeBtn);
      }
    });
  }

  const checkExist = setInterval(addCloseButton, 1000);
  setTimeout(() => clearInterval(checkExist), 5000);
})();
